import AMapLoader from '@amap/amap-jsapi-loader';

/**
 * * 初始化高德地图
 * @param {Object} config
 * @param {string} config.container 地图容器的选择器
 * @param {Object} config.options 地图的实例配置项
 * @param {string[]} config.plugins 地图插件列表
 * @param {Function} config.callback  加载回调
 */
export function initAMap({
  container,
  version = '2.0',
  options = { zoom: 18 },
  plugins = [],
  callback = AMap => ({ AMap, map: new AMap.Map(container, options) })
}) {
  return AMapLoader.load({
    plugins,
    version, // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    key: 'eef8d639480526c99c34a6a2a75ee253' // 申请好的Web端开发者Key，首次调用 load 时必填
  })
    .then(callback)
    .catch(console.error);
}

/**
 * * 根据浏览器获取当前定位
 * @param {Object} AMap 高德地图
 */
export function geolocation({ AMap, map = AMap, markerOptions }) {
  return new Promise((resolve, reject) => {
    map.plugin('AMap.Geolocation', function() {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认：true
        timeout: 5000, // 设置定位超时时间，默认：无穷大
        zoomToAccuracy: false, //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        showMarker: false, //定位成功后在定位到的位置显示点标记，默认：true
        showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
        circleOptions: {
          strokeOpacity: 0,
          fillOpacity: 0,
          bubble: true
        },
        markerOptions,
        showButton: false //显示定位按钮，默认：true
      });

      map.addControl(geolocation);

      geolocation.getCurrentPosition(function(status, result) {
        if (status == 'complete') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    });
  });
}
/**
 *
 */
export function mapGeolocation({ AMap, map = AMap, markerOptions }) {
  return new Promise((resolve, reject) => {
    map.plugin('AMap.Geolocation', function() {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认：true
        timeout: 5000, // 设置定位超时时间，默认：无穷大
        zoomToAccuracy: false, //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
        showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
        circleOptions: {
          strokeOpacity: 0,
          fillOpacity: 0,
          bubble: true
        },
        markerOptions,
        showButton: false //显示定位按钮，默认：true
      });
      // map.addControl(geolocation);
      geolocation.getCurrentPosition(function(status, result) {
        if (status == 'complete') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    });
  });
}

/**
 * * 获取当前地图中心点城市
 * @param {Object} map
 */
export function getMapCity(map) {
  return new Promise(resolve => {
    map.getCity(resolve);
  });
}
